/* Inner Compass — Gebruiksvoorwaarden.
 * Dutch is the authoritative version. English is a faithful translation.
 * Last updated: 1 October 2026. */

export const termsContent = {
  nl: [
    {
      heading: "1. Toepasselijkheid",
      body: [
        "Deze voorwaarden zijn van toepassing op het gebruik van de website, mobiele applicatie, webapplicatie en overige diensten van Inner Compass, gezamenlijk aangeduid als de \"Dienst\".",
        "Inner Compass is een Nederlandse eenmanszaak, ingeschreven bij de Kamer van Koophandel onder nummer 42129904.",
        "Door een account aan te maken of de Dienst te gebruiken, ga je akkoord met deze voorwaarden voor zover dit volgens toepasselijk recht is toegestaan.",
      ],
    },
    {
      heading: "2. De Dienst",
      body: ["Inner Compass is een digitale dienst gericht op ondersteuning van mentaal en emotioneel welzijn.", "Inner Compass kan onder andere functies aanbieden voor:"],
      list: [
        "check-ins;",
        "reflecties;",
        "dagboekgebruik;",
        "welzijnsinzichten;",
        "herstelplanning;",
        "persoonlijke strategieën;",
        "AI-ondersteunde gesprekken;",
        "persoonlijke context en herinneringen;",
        "veiligheidsinformatie;",
        "samenwerking met organisaties of professionals, indien deze functionaliteit beschikbaar is.",
      ],
      note: "Functies kunnen verschillen per accounttype, abonnement, organisatie of versie van de Dienst.",
    },
    {
      heading: "3. Geschiktheid",
      body: [
        "Je moet minimaal 16 jaar oud zijn om zelfstandig een Inner Compass-account te gebruiken, tenzij voor een specifieke situatie een andere geldige wettelijke regeling geldt.",
        "Wanneer je jonger bent dan 18 jaar, kunnen aanvullende wettelijke regels van toepassing zijn.",
      ],
    },
    {
      heading: "4. Geen medische behandeling",
      body: [
        "Inner Compass is geen arts, psycholoog, psychotherapeut, psychiater, medische instelling of hulpdienst.",
        "De Dienst is bedoeld voor ondersteuning en reflectie rondom welzijn.",
        "Inner Compass stelt geen medische diagnose en is niet bedoeld als vervanging voor professionele medische, psychologische of psychiatrische zorg.",
        "Gebruik informatie uit Inner Compass niet als enige basis voor medische of andere belangrijke beslissingen.",
      ],
    },
    {
      heading: "5. Crisissituaties",
      body: [
        "Inner Compass is geen nood- of crisisdienst.",
        "AI en andere automatische systemen kunnen signalen missen, verkeerd interpreteren of te laat herkennen.",
        "Wanneer jij of iemand anders in onmiddellijk gevaar verkeert, neem dan rechtstreeks contact op met de lokale hulpdiensten.",
        "In Nederland: bel bij acuut gevaar 112.",
        "Voor hulp bij gedachten aan zelfdoding kun je contact opnemen met 113 Zelfmoordpreventie.",
        "Vertrouw in een noodsituatie niet uitsluitend op Inner Compass.",
      ],
    },
    {
      heading: "6. Kunstmatige intelligentie",
      body: ["Inner Compass gebruikt kunstmatige intelligentie.", "Je begrijpt dat:"],
      list: [
        "AI automatisch gegenereerde antwoorden produceert;",
        "AI fouten kan maken;",
        "antwoorden onvolledig of onjuist kunnen zijn;",
        "AI context verkeerd kan interpreteren;",
        "AI geen menselijk professioneel oordeel vervangt.",
      ],
      note: "Je blijft zelf verantwoordelijk voor beslissingen die je neemt naar aanleiding van automatisch gegenereerde informatie.",
    },
    {
      heading: "7. Account en beveiliging",
      body: "Je bent verantwoordelijk voor:",
      list: [
        "het verstrekken van juiste registratiegegevens;",
        "het beschermen van je inloggegevens;",
        "het niet bewust beschikbaar stellen van je persoonlijke account aan onbevoegde derden;",
        "het melden van vermoedelijk onbevoegde toegang.",
      ],
      note: "Accounts zijn persoonlijk en mogen niet zonder toestemming worden overgedragen.",
    },
    {
      heading: "8. Toegestaan gebruik",
      body: "Je mag Inner Compass niet gebruiken om:",
      list: [
        "toepasselijke wetgeving te overtreden;",
        "rechten van anderen te schenden;",
        "systemen onbevoegd binnen te dringen;",
        "beveiligingsmaatregelen te omzeilen;",
        "malware of schadelijke code te verspreiden;",
        "de Dienst opzettelijk te verstoren;",
        "zonder toestemming geautomatiseerd grote hoeveelheden gegevens te verzamelen;",
        "je op misleidende wijze voor iemand anders of een andere organisatie voor te doen.",
      ],
    },
    {
      heading: "9. Jouw inhoud",
      body: [
        "Persoonlijke inhoud die je in Inner Compass invoert blijft van jou.",
        "Je verleent Inner Compass voor zover noodzakelijk het recht om deze inhoud technisch op te slaan, te verwerken, te beveiligen, over te dragen aan noodzakelijke dienstverleners en aan jou weer te geven voor het leveren van de Dienst.",
        "Dit geeft Inner Compass geen eigendom over jouw persoonlijke inhoud.",
      ],
    },
    {
      heading: "10. Intellectueel eigendom",
      body: [
        "De software, vormgeving, merkuitingen, logo's, teksten en overige materialen van Inner Compass zijn beschermd door toepasselijke intellectuele-eigendomsrechten.",
        "Je krijgt een beperkt, persoonlijk, niet-exclusief en niet-overdraagbaar gebruiksrecht om de Dienst te gebruiken overeenkomstig deze voorwaarden.",
        "Je mag beschermde onderdelen niet zonder toestemming kopiëren, verkopen, distribueren of commercieel exploiteren, behalve voor zover de wet dit toestaat.",
      ],
    },
    {
      heading: "11. Beschikbaarheid",
      body: [
        "We streven naar een betrouwbare en veilige Dienst, maar kunnen niet garanderen dat Inner Compass altijd zonder onderbreking, fout of storing beschikbaar is.",
        "Onderhoud, beveiligingsincidenten, storingen bij externe leveranciers of andere technische omstandigheden kunnen tijdelijke onderbrekingen veroorzaken.",
      ],
    },
    {
      heading: "12. Wijzigingen aan de Dienst",
      body: [
        "Inner Compass wordt doorlopend ontwikkeld.",
        "Functies kunnen worden toegevoegd, aangepast of verwijderd.",
        "Wanneer wijzigingen wezenlijke gevolgen hebben voor een betaalde overeenkomst of voor wettelijke consumentenrechten, handelen we overeenkomstig toepasselijk recht.",
      ],
    },
    {
      heading: "13. Betaalde diensten en abonnementen",
      body: [
        "Inner Compass kan gratis en betaalde onderdelen aanbieden.",
        "Wanneer een betaald abonnement of betaalde functionaliteit wordt aangeboden, worden vóór aankoop relevante informatie over onder andere prijs, factureringsperiode, functionaliteit en opzegging weergegeven.",
        "Een gebruiker wordt alleen belast nadat met de aankoop is ingestemd.",
        "Voor aankopen via Apple App Store, Google Play of een andere externe betalingsdienst kunnen daarnaast de voorwaarden van dat platform gelden.",
      ],
    },
    {
      heading: "14. Opzegging en accountverwijdering",
      body: [
        "Je kunt stoppen met het gebruik van Inner Compass.",
        "Wanneer accountverwijdering beschikbaar is, kun je je account verwijderen via de beschikbare accountinstellingen of het beschreven verwijderproces.",
        "Meer informatie staat op /delete-account.",
        "Wanneer een abonnement afzonderlijk via een externe appstore of betalingsprovider wordt beheerd, kan het noodzakelijk zijn dat abonnement afzonderlijk via dat platform op te zeggen.",
      ],
    },
    {
      heading: "15. Opschorting of beëindiging door Inner Compass",
      body: "We kunnen toegang tot de Dienst beperken, opschorten of beëindigen wanneer dit redelijkerwijs noodzakelijk is wegens bijvoorbeeld:",
      list: [
        "ernstige of herhaalde schending van deze voorwaarden;",
        "fraude of misbruik;",
        "beveiligingsrisico's;",
        "bescherming van andere gebruikers;",
        "wettelijke verplichtingen.",
      ],
      note: "Waar redelijkerwijs mogelijk en wettelijk vereist, informeren wij de betreffende gebruiker.",
    },
    {
      heading: "16. Aansprakelijkheid",
      body: [
        "Inner Compass streeft ernaar de Dienst zorgvuldig en betrouwbaar te leveren.",
        "Niets in deze voorwaarden sluit aansprakelijkheid uit of beperkt deze voor zover dat op grond van dwingend toepasselijk recht niet is toegestaan.",
        "Voor zover wettelijk toegestaan is Inner Compass niet aansprakelijk voor indirecte schade die uitsluitend voortvloeit uit onjuist gebruik van de Dienst, automatisch gegenereerde informatie of omstandigheden buiten onze redelijke controle.",
        "Deze bepaling doet geen afbreuk aan dwingende consumentenrechten.",
      ],
    },
    {
      heading: "17. Overmacht",
      body:
        "Inner Compass is, voor zover wettelijk toegestaan, niet verantwoordelijk voor tekortkomingen die redelijkerwijs buiten onze controle liggen, zoals grootschalige netwerkstoringen, uitval van essentiële infrastructuur, natuurrampen, cyberincidenten buiten onze redelijke controle of overheidsmaatregelen.",
    },
    {
      heading: "18. Privacy",
      body: ["Op de verwerking van persoonsgegevens is onze Privacyverklaring van toepassing.", "Deze is beschikbaar op /privacy."],
    },
    {
      heading: "19. Toepasselijk recht",
      body: [
        "Op deze voorwaarden is Nederlands recht van toepassing.",
        "Wanneer je consument bent, behoud je de bescherming van dwingende consumentenwetgeving die op jou van toepassing is.",
        "Geschillen worden voorgelegd aan de bevoegde rechter volgens de regels van toepasselijk recht.",
      ],
    },
    {
      heading: "20. Wijzigingen in deze voorwaarden",
      body: [
        "We kunnen deze voorwaarden aanpassen wanneer daarvoor een redelijke aanleiding bestaat, bijvoorbeeld vanwege wijzigingen aan de Dienst, wetgeving, beveiliging of bedrijfsvoering.",
        "Bij materiële wijzigingen informeren wij gebruikers op passende wijze.",
        "De meest recente versie is beschikbaar via de website.",
      ],
    },
    {
      heading: "21. Contact",
      body: ["Inner Compass", "Eenmanszaak", "KvK: 42129904", "Nederland"],
      list: ["contact@innercompass.tech", "support@innercompass.tech"],
    },
  ],
  en: [
    {
      heading: "1. Scope",
      body: [
        "These terms apply to the use of the website, mobile application, web application and other services of Inner Compass, collectively referred to as the \"Service\".",
        "Inner Compass is a Dutch sole proprietorship (eenmanszaak), registered with the Chamber of Commerce under number 42129904.",
        "By creating an account or using the Service, you agree to these terms to the extent permitted under applicable law.",
      ],
    },
    {
      heading: "2. The Service",
      body: ["Inner Compass is a digital service focused on supporting mental and emotional wellbeing.", "Inner Compass may offer features such as:"],
      list: [
        "check-ins;",
        "reflections;",
        "journal use;",
        "wellbeing insights;",
        "recovery planning;",
        "personal strategies;",
        "AI-assisted conversations;",
        "personal context and memories;",
        "safety information;",
        "collaboration with organisations or professionals, when this functionality is available.",
      ],
      note: "Features may vary by account type, subscription, organisation or version of the Service.",
    },
    {
      heading: "3. Eligibility",
      body: [
        "You must be at least 16 years old to use an Inner Compass account independently, unless a different valid legal rule applies for a specific situation.",
        "If you are under 18, additional legal rules may apply.",
      ],
    },
    {
      heading: "4. No medical treatment",
      body: [
        "Inner Compass is not a doctor, psychologist, psychotherapist, psychiatrist, medical institution or emergency service.",
        "The Service is intended for support and reflection around wellbeing.",
        "Inner Compass does not provide a medical diagnosis and is not intended as a replacement for professional medical, psychological or psychiatric care.",
        "Do not use information from Inner Compass as the sole basis for medical or other important decisions.",
      ],
    },
    {
      heading: "5. Crisis situations",
      body: [
        "Inner Compass is not an emergency or crisis service.",
        "AI and other automated systems can miss signals, misinterpret them or recognise them too late.",
        "If you or someone else is in immediate danger, contact your local emergency services directly.",
        "In the Netherlands: in an emergency call 112.",
        "For help with thoughts of suicide you can contact 113 Zelfmoordpreventie.",
        "Do not rely exclusively on Inner Compass in an emergency.",
      ],
    },
    {
      heading: "6. Artificial intelligence",
      body: ["Inner Compass uses artificial intelligence.", "You understand that:"],
      list: [
        "AI produces automatically generated replies;",
        "AI can make mistakes;",
        "replies can be incomplete or incorrect;",
        "AI can misinterpret context;",
        "AI does not replace human professional judgement.",
      ],
      note: "You remain responsible for decisions you take on the basis of automatically generated information.",
    },
    {
      heading: "7. Account and security",
      body: "You are responsible for:",
      list: [
        "providing accurate registration details;",
        "protecting your login credentials;",
        "not knowingly making your personal account available to unauthorised third parties;",
        "reporting suspected unauthorised access.",
      ],
      note: "Accounts are personal and may not be transferred without consent.",
    },
    {
      heading: "8. Permitted use",
      body: "You may not use Inner Compass to:",
      list: [
        "violate applicable law;",
        "infringe the rights of others;",
        "intrude on systems without authorisation;",
        "circumvent security measures;",
        "distribute malware or harmful code;",
        "intentionally disrupt the Service;",
        "collect large amounts of data in an automated way without permission;",
        "deceptively impersonate another person or organisation.",
      ],
    },
    {
      heading: "9. Your content",
      body: [
        "Personal content you enter in Inner Compass remains yours.",
        "You grant Inner Compass, insofar as necessary, the right to technically store, process, secure, transmit to necessary service providers and display this content back to you for the purpose of providing the Service.",
        "This does not give Inner Compass ownership of your personal content.",
      ],
    },
    {
      heading: "10. Intellectual property",
      body: [
        "The software, design, brand elements, logos, texts and other materials of Inner Compass are protected by applicable intellectual-property rights.",
        "You receive a limited, personal, non-exclusive and non-transferable right of use to use the Service in accordance with these terms.",
        "You may not copy, sell, distribute or commercially exploit protected elements without permission, except insofar as the law permits.",
      ],
    },
    {
      heading: "11. Availability",
      body: [
        "We aim for a reliable and secure Service but cannot guarantee that Inner Compass is always available without interruption, error or disruption.",
        "Maintenance, security incidents, outages at external suppliers or other technical circumstances can cause temporary interruptions.",
      ],
    },
    {
      heading: "12. Changes to the Service",
      body: [
        "Inner Compass is developed continuously.",
        "Features may be added, changed or removed.",
        "Where changes have material consequences for a paid agreement or for statutory consumer rights, we act in accordance with applicable law.",
      ],
    },
    {
      heading: "13. Paid services and subscriptions",
      body: [
        "Inner Compass may offer free and paid elements.",
        "Where a paid subscription or paid functionality is offered, relevant information about, among other things, price, billing period, functionality and cancellation is shown before purchase.",
        "A user is only charged after the purchase has been agreed to.",
        "For purchases via the Apple App Store, Google Play or another external payment service, the terms of that platform may additionally apply.",
      ],
    },
    {
      heading: "14. Cancellation and account deletion",
      body: [
        "You can stop using Inner Compass.",
        "When account deletion is available, you can delete your account via the available account settings or the described deletion process.",
        "More information is available at /delete-account.",
        "When a subscription is managed separately via an external app store or payment provider, it may be necessary to cancel that subscription separately via that platform.",
      ],
    },
    {
      heading: "15. Suspension or termination by Inner Compass",
      body: "We may restrict, suspend or terminate access to the Service when this is reasonably necessary, for example due to:",
      list: [
        "serious or repeated breach of these terms;",
        "fraud or abuse;",
        "security risks;",
        "protection of other users;",
        "legal obligations.",
      ],
      note: "Where reasonably possible and legally required, we inform the user concerned.",
    },
    {
      heading: "16. Liability",
      body: [
        "Inner Compass aims to deliver the Service carefully and reliably.",
        "Nothing in these terms excludes or limits liability to the extent that this is not permitted under mandatory applicable law.",
        "To the extent permitted by law, Inner Compass is not liable for indirect damages that exclusively arise from incorrect use of the Service, automatically generated information or circumstances outside our reasonable control.",
        "This provision does not affect mandatory consumer rights.",
      ],
    },
    {
      heading: "17. Force majeure",
      body:
        "To the extent permitted by law, Inner Compass is not responsible for shortcomings that are reasonably outside our control, such as large-scale network outages, failure of essential infrastructure, natural disasters, cyber incidents outside our reasonable control or government measures.",
    },
    {
      heading: "18. Privacy",
      body: ["Our Privacy Statement applies to the processing of personal data.", "It is available at /privacy."],
    },
    {
      heading: "19. Governing law",
      body: [
        "These terms are governed by Dutch law.",
        "If you are a consumer, you retain the protection of mandatory consumer legislation that applies to you.",
        "Disputes will be submitted to the competent court in accordance with the rules of applicable law.",
      ],
    },
    {
      heading: "20. Changes to these terms",
      body: [
        "We may adjust these terms when there is a reasonable reason to do so, for example because of changes to the Service, legislation, security or business operations.",
        "In the event of material changes we inform users in an appropriate way.",
        "The most recent version is available on the website.",
      ],
    },
    {
      heading: "21. Contact",
      body: ["Inner Compass", "Sole proprietorship", "Chamber of Commerce (KvK): 42129904", "The Netherlands"],
      list: ["contact@innercompass.tech", "support@innercompass.tech"],
    },
  ],
};
